import { render, staticRenderFns } from "./TransferAccount.vue?vue&type=template&id=348a347c&scoped=true&"
import script from "./TransferAccount.vue?vue&type=script&lang=js&"
export * from "./TransferAccount.vue?vue&type=script&lang=js&"
import style0 from "./TransferAccount.vue?vue&type=style&index=0&id=348a347c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348a347c",
  null
  
)

export default component.exports